import React from "react";
import { SearchBar } from "components/search/SearchBar";
import { Paragraph } from "components/core/Typography";

import "./SearchSection.scss";
import { Heading } from "components/storages/Common";

const SearchSection = () => (
	<div className="search-section">
		<SearchBar
			buttonText="Search"
			id="bottom-search-bar"
			label="Enter ZIP code..."
			theme="lightBlue"
		>
			<Heading
				size="large"
				content="Update Your Storage Search"
				level="2"
			/>
			<Paragraph
				last
				size="small"
			>
				Find storage units near you
			</Paragraph>
		</SearchBar>
	</div>
);

export default SearchSection;
